import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '@ui-app/components/spinner/spinner.service';
import { BaseComponent } from '@ui-app/components/base.component';

@Component({
  selector: 'ui-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less']
})
export class SpinnerComponent extends BaseComponent implements OnInit {

    isShowSpinner: boolean = false;

    constructor(private spinnerService: SpinnerService) {
        super();
    }

    ngOnInit(): void {
        this.subs = this.spinnerService.showSpinner.subscribe((result: boolean) => {
            this.isShowSpinner = result;
        });
    }

}
